import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchNearbyBusinesses } from "../../apis/business";

/**
 * Query options for an area map's nearby venues, shared by the what's-nearby SSR loader
 * and useNearbyBusinesses.
 *
 * @param businessId Area-map business id.
 * @returns Query options keyed ["nearbyBusinesses", businessId].
 */
export function nearbyBusinessesQueryOptions(businessId: string) {
  return queryOptions({
    queryKey: ["nearbyBusinesses", businessId],
    queryFn: () => fetchNearbyBusinesses(businessId),
  });
}

export function useNearbyBusinesses(businessId: string) {
  return useQuery({
    ...nearbyBusinessesQueryOptions(businessId),
    enabled: Boolean(businessId),
  });
}
